import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import LogoIcon from "../../../../media/images/icons/logo.svg";
import CustomButton from "../../../components/CustomButton";
import LoginIcon from "../../../../media/images/icons/login-newsvg";
import BigCar from "../../../../media/images/icons/bigCar";
import UserProfile from "../../../../media/images/icons/user-profile";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  handleUserLoginTabbar,
  changeLoginType,
} from "../../../../redux/features/settingSlice";

interface Props {
  open: boolean;
  handleClose: () => void;
}

const style = {
  position: "absolute" as "absolute",
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  flex: "1",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  minWidth: 350,
  height: "300px",
  border: "2px solid #000",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "15px",
  p: 2,
};

export default function LoginModal({ open, handleClose }: Props) {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiBox-root": {
          border: "none",
        },
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        direction: "rtl",
      }}
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <img src={LogoIcon} alt="" />
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "secondary.main",
            }}
          >
            ورود به اپلیکیشن{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: "1",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            overflow: "auto",
            mt: 3,
            pt: 2,
            paddingX: "4px",
          }}
        >
          <CustomButton
            // loading={loading}
            onClick={() => {
              dispatch(handleUserLoginTabbar("drivers"));
              navigate("/login");
            }}
            flexDirection="row"
            title="ورود رانندگان"
            justifyContent="space-between"
            bgColor="primary.main"
            width="100%"
            fSize="16px"
            fontWeight={500}
            px="10px"
            py="10px"
            borderRadius="10px"
            color="lightStatic.main"
            icon2={<LoginIcon size={28} />}
            icon1={<BigCar size={28} />}
          />
          <CustomButton
            // loading={loading}
            onClick={() => {
              dispatch(handleUserLoginTabbar("burdenOwner"));
              navigate("/login");
            }}
            flexDirection="row"
            title="ورود صاحبین بار"
            justifyContent="space-between"
            bgColor="primary.main"
            width="100%"
            fSize="16px"
            fontWeight={500}
            px="10px"
            py="10px"
            borderRadius="10px"
            color="lightStatic.main"
            icon2={<LoginIcon size={28} />}
            icon1={<UserProfile size={28} />}
          />
          <CustomButton
            // loading={loading}
            onClick={() => {
              dispatch(changeLoginType());
              navigate("/login");
            }}
            flexDirection="row"
            title="ورود شرکت حمل و نقل"
            justifyContent="space-between"
            bgColor="secondary.main"
            width="100%"
            fSize="16px"
            fontWeight={500}
            px="10px"
            py="10px"
            borderRadius="10px"
            color="lightStatic.main"
            icon2={<LoginIcon size={28} />}
            icon1={<BigCar size={28} />}
          />
        </Box>
      </Box>
    </Modal>
  );
}
